import React from 'react';
import { Github, Linkedin, Mail, Heart, Instagram,Twitter} from 'lucide-react';
import { personalInfo } from '../data/mock';

// Custom LeetCode SVG Icon Component
const LeetCodeIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M13.483 0a1.374 1.374 0 0 0-.961.438L7.116 6.226l-3.854 4.126a5.266 5.266 0 0 0-1.209 2.104 5.35 5.35 0 0 0-.125.513 5.527 5.527 0 0 0 .062 2.362 5.83 5.83 0 0 0 .349 1.017 5.938 5.938 0 0 0 1.271 1.818l4.277 4.193.039.038c2.248 2.165 5.852 2.133 8.063-.074l2.396-2.392c.54-.54.54-1.414.003-1.955a1.378 1.378 0 0 0-1.951-.003l-2.396 2.392a3.021 3.021 0 0 1-4.205.038l-.02-.019-4.276-4.193c-.652-.64-.972-1.469-.948-2.263a2.68 2.68 0 0 1 .066-.523 2.545 2.545 0 0 1 .619-1.164L9.13 8.114c1.058-1.134 3.204-1.27 4.43-.278l3.501 2.831c.593.48 1.461.387 1.94-.207a1.384 1.384 0 0 0-.207-1.943l-3.5-2.831c-.8-.647-1.766-1.045-2.774-1.202l2.015-2.158A1.384 1.384 0 0 0 13.483 0zm-2.866 12.815a1.38 1.38 0 0 0-1.38 1.382 1.38 1.38 0 0 0 1.38 1.382H20.79a1.38 1.38 0 0 0 1.38-1.382 1.38 1.38 0 0 0-1.38-1.382z"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: <Github className="w-5 h-5" />, href: personalInfo.github, label: 'GitHub' },
    { icon: <Linkedin className="w-5 h-5" />, href: personalInfo.linkedin, label: 'LinkedIn' },
    { icon: <LeetCodeIcon className="w-5 h-5" />, href: personalInfo.leetcode, label: 'LeetCode' },
    { icon: <Instagram className="w-5 h-5" />, href: personalInfo.instagram, label: 'Instagram' },
    { icon: <Twitter className="w-5 h-5" />, href: personalInfo.Twitter, label: 'Twitter' },
    { icon: <Mail className="w-5 h-5" />, href: `mailto:${personalInfo.email}`, label: 'Email' }
  ];

  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-12">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Top Section */}
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            {/* Left: Branding */}
            <div>
              <h3 className="text-2xl font-bold text-white mb-2">
                <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                  {personalInfo.name.split(' ')[0]}
                </span>
              </h3>
              <p className="text-gray-400 text-sm">
                {personalInfo.title}
              </p>
            </div>

            {/* Middle: Quick Links */}
            <div>
              <h4 className="text-white font-semibold mb-4">Quick Links</h4>
              <div className="space-y-2">
                {['About', 'Skills', 'Projects', 'Certifications', 'Contact'].map((item) => (
                  <a
                    key={item}
                    href={`#${item.toLowerCase()}`}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(`#${item.toLowerCase()}`)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="block text-gray-400 hover:text-blue-400 transition-colors text-sm"
                  >
                    {item}
                  </a>
                ))}
              </div>
            </div>

            {/* Right: Contact */}
            <div>
              <h4 className="text-white font-semibold mb-4">Get in Touch</h4>
              <p className="text-gray-400 text-sm mb-4">
                Feel free to reach out for collaborations or just a friendly hello!
              </p>
              <a 
                href={`mailto:${personalInfo.email}`}
                className="text-blue-400 hover:text-blue-300 text-sm transition-colors"
              >
                {personalInfo.email}
              </a>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-slate-800 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              {/* Copyright */}
              <p className="text-gray-400 text-sm">
                © {currentYear} {personalInfo.name}. Made with <Heart className="w-4 h-4 inline text-red-500 fill-red-500" /> for showcasing my work.
              </p>

              {/* Social Links */}
              <div className="flex gap-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-lg bg-slate-900 border border-slate-800 flex items-center justify-center text-gray-400 hover:text-blue-400 hover:border-blue-500/30 transition-all duration-300"
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
